import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import logo from "../../../assets/images/Jobal.svg";
import authService from "../../../utils/services/authService";
import styles from "./adminMenu.module.scss";

const AdminMenu = ({ userData, setIsNavOpen }) => {
  const [accOpen, setAccOpen] = useState(false);
  const linkClickHandle = () => {
    setIsNavOpen((prev) => !prev);
  };

  const logoutclickHandle = () => {
    authService.logoutUser();
  };

  const accordionHandle = () => {
    setAccOpen((prev) => !prev);
  };

  return (
    <section className={styles.adminMenu}>
      <img className={styles.menuLogo} src={logo} alt="" />

      <section className={styles.navLinks}>
        <section className={styles.accordion} onClick={accordionHandle}>
          <div className={styles.label}>
            <div className={styles.labelLeft}>
              <img
                className={styles.linkIcon}
                src={require("../../../assets/images/dashboard-icon.png")}
                alt=""
              />
              <p className={styles.labelLeft_heading}>Dashboard</p>
            </div>
            <img
              className={styles.label_arrow}
              src={require("../../../assets/images/angle-down.png")}
              alt=""
            />
          </div>
          <div
            className={`${styles.accordionItems} ${accOpen ? styles.open : ""}`}
          >
            <NavLink
              to="/admin/dashboard"
              className={styles.accordionItems_link}
            >
              Dashboard
            </NavLink>
            <NavLink to="/admin/users" className={styles.accordionItems_link}>
              Users
            </NavLink>
            <NavLink to="/admin/tickets" className={styles.accordionItems_link}>
              Tickets
            </NavLink>
          </div>
        </section>

        <NavLink
          to="/admin/tickets"
          className={styles.navLinks_link}
          onClick={linkClickHandle}
        >
          <img
            className={styles.linkIcon}
            src={require("../../../assets/images/support-icon.png")}
            alt=""
          />{" "}
          Tickets
        </NavLink>

        <NavLink
          className={styles.navLinks_link}
          onClick={() => {
            logoutclickHandle();
            linkClickHandle();
          }}
        >
          <img
            className={styles.linkIcon}
            src={require("../../../assets/images/logout-icon.png")}
            alt=""
          />{" "}
          Logout
        </NavLink>
      </section>
    </section>
  );
};

export default AdminMenu;
